import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, of } from 'rxjs';
import { IPSetting } from 'models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private readonly http = inject(HttpClient);

  IP_API_URL: string = environment.Ip_Api_URL;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  /**
   * Returns fallback location data when the IP API is unavailable
   * Uses world center coordinates for a reasonable default map view
   */
  private getFallbackLocation(): IPSetting {
    return {
      query: '',
      hostname: '',
      city: '',
      region: '',
      regionName: '',
      country: '',
      countryCode: '',
      lat: 0, // World center - provides a good default map view
      lon: 0, // World center - provides a good default map view
      org: '',
      isp: '',
      as: '',
      zip: '',
      timezone: 'UTC',
      status: 'fallback',
    };
  }

  getIpData() {
    return this.http.get<IPSetting>(this.IP_API_URL).pipe(
      catchError((error) => {
        console.warn(
          'Location API unavailable, using fallback location:',
          error,
        );
        return of(this.getFallbackLocation());
      }),
    );
  }

  /**
   * Gets the user's position with graceful fallback
   * Always resolves with either real location data or fallback coordinates
   */
  getPosition(): Promise<IPSetting> {
    return new Promise((resolve) => {
      this.getIpData().subscribe({
        next: (res: IPSetting | PromiseLike<IPSetting>) => {
          resolve(res);
        },
        error: (error) => {
          // This should never happen due to catchError in getIpData(),
          // but providing extra safety
          console.error('Unexpected error in getPosition:', error);
          resolve(this.getFallbackLocation());
        },
      });
    });
  }
}
